// Where a hosted hero or card lives. CLIENT-SAFE — no Supabase client, no
// service key, just the one string the bucket's public objects are read at.
//
// Split out of heroStore (which is the WRITE side, and imports the service
// client) so the page can hand a browser the hosted card's address directly.
// The card used to be reached only through /api/brand/post-card, which meant a
// lambda woke up, HEAD-probed storage and answered 302 for every thumbnail on
// the index — a second of function time per card before the browser had even
// started fetching the file. Now the browser asks storage first and only falls
// back to the route when the file is not there yet (components/company/PostFace).

export const HERO_BUCKET = "email-heroes";

/** The public URL a stored hero WOULD live at (whether or not it exists yet). */
export function hostedHeroUrl(key: string): string | null {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  if (!url) return null;
  return `${url.replace(/\/$/, "")}/storage/v1/object/public/${HERO_BUCKET}/${encodeURIComponent(key)}.png`;
}
